import { useEffect, useMemo } from 'react';
import Field from '@/components/common/Field.jsx';
import { purchaseFormActions, usePurchaseForm } from '@/state/forms/purchaseFormSlice.js';

const actions = purchaseFormActions();

const importeFields = [
  { name: 'neto', label: 'Neto gravado' },
  { name: 'iva21', label: 'IVA 21%' },
  { name: 'iva105', label: 'IVA 10.5%' },
  { name: 'iva27', label: 'IVA 27%' },
  { name: 'exento', label: 'Exento' },
  { name: 'noGravado', label: 'No gravado' },
  { name: 'percepIva', label: 'Percepción IVA' },
  { name: 'percepIibb', label: 'Percepción IIBB' },
  { name: 'otros', label: 'Otros' },
];

export default function ImportesPanel() {
  const importes = usePurchaseForm(state => state.importes);

  useEffect(() => {
    actions.recalcImportes();
  }, []);

  const difference = useMemo(() => {
    if (!importes) return 0;
    const calculated = Number(importes.totalCalculado ?? 0);
    const total = Number(importes.total ?? 0);
    return Number((total - calculated).toFixed(2));
  }, [importes]);

  return (
    <section className="rounded-2xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--panel),0.75)] p-6 shadow-[0_20px_40px_rgba(var(--shadow),0.14)]">
      <header className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="text-lg font-semibold text-[rgb(var(--fg))]">Importes</h2>
          <p className="text-sm text-[rgba(var(--muted),0.85)]">Desglosá tributos y montos para validar el total del comprobante.</p>
        </div>
      </header>
      <div className="mt-6 grid grid-cols-12 gap-4">
        {importeFields.map(field => (
          <div key={field.name} className="col-span-12 sm:col-span-6 lg:col-span-4">
            <Field label={field.label} htmlFor={`importe-${field.name}`}>
              <input
                id={`importe-${field.name}`}
                type="number"
                value={importes?.[field.name] ?? 0}
                onChange={event => actions.setImporte(field.name, event.target.value)}
                className="w-full rounded-xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--panel),0.6)] px-4 py-3 text-sm text-[rgb(var(--fg))] shadow-inner focus:outline-none focus:ring-2 focus:ring-[rgb(var(--ring))]"
              />
            </Field>
          </div>
        ))}
        <div className="col-span-12 sm:col-span-6 lg:col-span-4">
          <Field label="Total" htmlFor="importe-total" required>
            <input
              id="importe-total"
              type="number"
              value={importes?.total ?? 0}
              onChange={event => actions.setTotal(event.target.value)}
              className="w-full rounded-xl border border-[rgba(var(--border),0.8)] bg-[rgba(var(--panel),0.8)] px-4 py-3 text-sm font-semibold text-[rgb(var(--fg))] shadow-inner focus:outline-none focus:ring-2 focus:ring-[rgb(var(--ring))]"
            />
          </Field>
        </div>
      </div>
      <div
        className={`mt-6 rounded-2xl border px-4 py-3 text-sm ${
          Math.abs(difference) < 1
            ? 'border-[rgba(var(--border),0.45)] bg-[rgba(var(--panel),0.55)] text-[rgba(var(--muted),0.85)]'
            : 'border-[rgba(var(--brand),0.35)] bg-[rgba(var(--brand),0.1)] text-[rgb(var(--brand-700))]'
        }`}
        aria-live="polite"
      >
        {Math.abs(difference) < 1 ? (
          <span>El total calculado coincide con el total ingresado.</span>
        ) : (
          <span>
            Atención: el total ingresado difiere del calculado por{' '}
            {Math.abs(difference).toLocaleString('es-AR', {
              style: 'currency',
              currency: 'ARS',
            })}
            .
          </span>
        )}
      </div>
    </section>
  );
}
